import UpdateBar from "./components/UpdateBar";
import Header from "./components/Header";
import Hero from "./components/Hero";
import HeatBoard from "./components/HeatBoard";
import DigFeed from "./components/DigFeed";
import Zones from "./components/Zones";
import TimelineSection from "./components/TimelineSection";
import EvidenceSection from "./components/EvidenceSection";
import SubscribeCta from "./components/SubscribeCta";
import FooterBar from "./components/FooterBar";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50 text-foreground-950">
      <UpdateBar />
      <Header />
      <main>
        <Hero />
        <HeatBoard />
        <DigFeed />
        <Zones />
        <TimelineSection />
        <EvidenceSection />
        <SubscribeCta />
      </main>
      <FooterBar />
    </div>
  );
}